import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js/instance/includes';
import * as React from 'react';
import ReactDOM__default from 'react-dom';
import { mobile, api } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import { OpenAppBtn } from '../../open-app-btn/index.js';
import { LegacySearchBox } from '../../search-box/legacy-search-box/index.js';
import { isGeneralMobile } from '../../utils/hooks.js';
import { prependPrefix } from '../../utils/style.js';
import { NavLinks } from './components/nav-links.js';
import { UserCenter } from './components/user-center/index.js';
import { HeaderContextProvider, useHeaderContext } from './context.js';
export { EDeviceType } from './types.js';

var _excluded = ["containerId"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var SWIMLANE_NAME = process.env.SWIMLANE === 'default' ? '' : process.env.SWIMLANE;

var Swimlane = function Swimlane(_ref) {
  var name = _ref.name;

  if (!api.isUAT || !name) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: prependPrefix('swimlane')
  }, name);
};

var THeader = function THeader(_ref2) {
  var className = _ref2.className,
      showSearchBox = _ref2.showSearchBox,
      showSearchSuggest = _ref2.showSearchSuggest,
      showUserCenter = _ref2.showUserCenter,
      extInfo = _ref2.extInfo,
      showOpenAppBtn = _ref2.showOpenAppBtn,
      openAppBtnText = _ref2.openAppBtnText;

  var _useHeaderContext = useHeaderContext(),
      isMobileView = _useHeaderContext.isMobileView;

  var realClasses = isMobileView ? prependPrefix('legacy-header-mobile') : prependPrefix('legacy-header');
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(realClasses, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: prependPrefix('content')
  }, /*#__PURE__*/React.createElement("div", {
    className: prependPrefix('header-nav')
  }, /*#__PURE__*/React.createElement(NavLinks, null)), /*#__PURE__*/React.createElement("div", {
    className: prependPrefix('header-opts')
  }, isMobileView && showOpenAppBtn && /*#__PURE__*/React.createElement(OpenAppBtn, {
    className: "header-open-app-btn",
    type: extInfo === null || extInfo === void 0 ? void 0 : extInfo.type,
    path: extInfo === null || extInfo === void 0 ? void 0 : extInfo.path,
    options: extInfo === null || extInfo === void 0 ? void 0 : extInfo.options
  }, /*#__PURE__*/React.createElement("div", {
    className: prependPrefix('open-app-btn')
  }, openAppBtnText)), showSearchBox && /*#__PURE__*/React.createElement(LegacySearchBox, {
    className: isMobileView ? prependPrefix('header-mobile-search') : prependPrefix('header-pc-search'),
    showSearchSuggest: showSearchSuggest,
    placeholder: "\u641C\u7D22",
    isMobile: isMobileView
  }), showUserCenter && /*#__PURE__*/React.createElement(UserCenter, null))));
};

var LegacyHeader = function LegacyHeader(_ref3) {
  var _context;

  var className = _ref3.className,
      type = _ref3.type,
      _ref3$swimlane = _ref3.swimlane,
      swimlane = _ref3$swimlane === void 0 ? SWIMLANE_NAME : _ref3$swimlane,
      _ref3$showOpenAppBtn = _ref3.showOpenAppBtn,
      showOpenAppBtn = _ref3$showOpenAppBtn === void 0 ? true : _ref3$showOpenAppBtn,
      _ref3$showGuestBox = _ref3.showGuestBox,
      showGuestBox = _ref3$showGuestBox === void 0 ? !_includesInstanceProperty(_context = window.location.pathname).call(_context, '/member/login') : _ref3$showGuestBox,
      _ref3$showSearchBox = _ref3.showSearchBox,
      showSearchBox = _ref3$showSearchBox === void 0 ? true : _ref3$showSearchBox,
      _ref3$showSearchSugge = _ref3.showSearchSuggest,
      showSearchSuggest = _ref3$showSearchSugge === void 0 ? true : _ref3$showSearchSugge,
      _ref3$showUserCenter = _ref3.showUserCenter,
      showUserCenter = _ref3$showUserCenter === void 0 ? true : _ref3$showUserCenter,
      startBtnConfig = _ref3.startBtnConfig,
      extInfo = _ref3.extInfo,
      _ref3$openAppBtnText = _ref3.openAppBtnText,
      openAppBtnText = _ref3$openAppBtnText === void 0 ? '下载 App' : _ref3$openAppBtnText;
  return /*#__PURE__*/React.createElement(HeaderContextProvider, {
    startBtnConfig: startBtnConfig,
    type: type,
    showGuestBox: showGuestBox
  }, /*#__PURE__*/React.createElement(Swimlane, {
    name: swimlane
  }), !mobile.isMissEvanApp() && /*#__PURE__*/React.createElement(THeader, {
    className: className,
    swimlane: swimlane,
    showSearchBox: showSearchBox,
    showSearchSuggest: showSearchSuggest,
    showUserCenter: showUserCenter,
    extInfo: extInfo,
    showOpenAppBtn: showOpenAppBtn,
    openAppBtnText: openAppBtnText
  }));
};
var DEFAULT_LEGACY_HEADER_CONTAINER_ID = 'CommonHeader';
var initLegacyHeader = function initLegacyHeader(opts) {
  var _opts$containerId = opts.containerId,
      containerId = _opts$containerId === void 0 ? DEFAULT_LEGACY_HEADER_CONTAINER_ID : _opts$containerId,
      otherOpts = _objectWithoutProperties(opts, _excluded);

  var container = document.getElementById(containerId);

  if (!container) {
    container = document.createElement('div');
    container.setAttribute('id', containerId);
    document.body.insertBefore(container, document.body.firstChild);
  }

  container.style.position = 'relative';
  container.style.zIndex = '99';
  container.style.width = '100%'; // 移动端 header fixed，需留出 header 高度以免挡住页面内容

  if (isGeneralMobile()) {
    container.style.paddingBottom = '40px';
  }

  ReactDOM__default.render( /*#__PURE__*/React.createElement(LegacyHeader, _objectSpread({}, otherOpts)), container);
};
var unmountLegacyHeader = function unmountLegacyHeader() {
  var containerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_LEGACY_HEADER_CONTAINER_ID;
  var container = document.getElementById(containerId);

  if (!container) {
    return;
  }

  ReactDOM__default.unmountComponentAtNode(container);
  container.remove();
};

export { LegacyHeader, initLegacyHeader, unmountLegacyHeader };
